import { IRectType } from '../imports/utils';

/**
 * @description 1x1 image に対する相対位置のrectをcropRectRelativeに対する相対位置に変換
 *
 *
 *
 *      0.0   0.2   0.4   0.6 0.7     1.0
 *  0.0  +-----------------------------+
 *       |                             |
 *  0.2  |     +---------------+       |
 *  0.3  |     |     +-----+   |       |
 *       |     |     |     |   |       |
 *  0.5  |     |     +-----+   |       |
 *       |     |               |       |
 *  0.7  |     +---------------+       |
 *       |                             |
 *       |                             |
 *  1.0  +-----------------------------+
 *
 * cropRectRelative = { top: 0.2, left: 0.2, width: 0.5, height: 0.5 }
 * rectRelative = { top: 0.3, left: 0.4, width: 0.2, height: 0.2 }
 * のとき，
 * toRectRelativeToCroppedRect(cropRectRelative, rectRelative)
 *  = { top: 0.2, left: 0.4, width: 0.4, height: 0.4 }
 * となる
 *
 */
export const toRectRelativeToCroppedRectFnGenerator = (
  cropRectRelative: IRectType
) => (rectRelative: IRectType): IRectType =>
  rectRelative.withMutations(rect =>
    rect
      .update('width', w => w / cropRectRelative.width)
      .update('height', h => h / cropRectRelative.height)
      .update('top', t => (t - cropRectRelative.top) / cropRectRelative.height)
      .update('left', l => (l - cropRectRelative.left) / cropRectRelative.width)
  );

/**
 * @description toRectRelativeToCroppedRectの逆演算
 */
export const fromRectRelativeToCroppedRectFnGenerator = (
  cropRectRelative: IRectType
) => (rectRelative: IRectType): IRectType =>
  rectRelative.withMutations(rect =>
    rect
      .update('width', w => w * cropRectRelative.width)
      .update('height', h => h * cropRectRelative.height)
      .update('top', t => t * cropRectRelative.height + cropRectRelative.top)
      .update('left', l => l * cropRectRelative.width + cropRectRelative.left)
  );
